import type { ZoneParams } from 'features/libra/stepComponents/zoneAnalysis/zoneAnalysisApi'
import isEqual from 'lodash/isEqual'

export const projectZoneGeometry = (zones: readonly ZoneParams[]) =>
  zones.map(({ id, zone_reference_image_id, drawing_bounds }) => ({
    id,
    imageId: zone_reference_image_id,
    rectangles: (drawing_bounds ?? []).map(
      ({ x_start, y_start, x_end, y_end }) => ({
        x_start,
        y_start,
        x_end,
        y_end,
      })
    ),
  }))

export const sameZoneGeometry = (
  previous: readonly ZoneParams[],
  next: readonly ZoneParams[]
) => isEqual(projectZoneGeometry(previous), projectZoneGeometry(next))
